import { useEffect, useState, useRef } from 'react';

export const useIntersectionVisibility = (thresholdPx: number) => {
  const [isVisible, setIsVisible] = useState(true);
  const elementRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!elementRef.current) return;

    const currentElement = elementRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: `-${thresholdPx}px`,
        threshold: [0, 1],
      },
    );

    observer.observe(currentElement);

    return () => {
      observer.unobserve(currentElement);
    };
  }, [thresholdPx]);

  return { isVisible, elementRef };
};
